import BadgeCategory from './BadgeCategory';
import BadgeDelete from './BadgeDelete';
import BadgeIcon from './BadgeIcon';
import BadgeLabel from './BadgeLabel';
import BadgeSeparator from './BadgeSeparator';
import BadgeDropdown from './BadgeDropdown';

export default {
	Category: BadgeCategory,
	DeleteAction: BadgeDelete,
	Icon: BadgeIcon,
	Label: BadgeLabel,
	Separator: BadgeSeparator,
	Dropdown: BadgeDropdown,
};
